module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "body_Praise--Heading3-"
  }, [_vm._v("Also by Mitzi"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Szereto")]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-1"
  }, [_vm._v("The Best New True Crime Stories: Seri"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("al")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Killers")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-2"
  }, [_vm._v("The Best New True Crime Stories: S"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("mall")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Towns")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Well-Mannered Crooks, Rogues &"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" Criminals")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Crimes of Passion, Obsession"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" & Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body ParaOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Partner"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("s in")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Crime")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328db454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories-2.vue
// module id = 63
// module chunks = 0